import { render, staticRenderFns } from "./RekamMedisRanap.vue?vue&type=template&id=e87e9b66&scoped=true&"
import script from "./RekamMedisRanap.vue?vue&type=script&lang=ts&"
export * from "./RekamMedisRanap.vue?vue&type=script&lang=ts&"
import style0 from "./RekamMedisRanap.vue?vue&type=style&index=0&id=e87e9b66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e87e9b66",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBadge,VCard,VChip,VChipGroup,VCol,VContainer,VDivider,VRow,VTab,VTabItem,VTabs,VToolbar})
